import { HttpClient } from '@angular/common/http';
import CONFIG from '../config'
import { AuthenticationService } from './authentication.service'
import { Platform } from '@ionic/angular';
import { HTTP } from '@ionic-native/http/ngx'
import { from } from 'rxjs';
import enviarToken from '../iterceptorNative';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class OadvService {

  constructor(public httpNative: HTTP, public http: HttpClient, public platform: Platform) { }

  guardarOADV(datos) {

    return new Promise((resolve, reject) => {
      this.http.post(CONFIG.API + '/api/derecho-via/', datos)
        .subscribe((reporte: any) => {
          resolve(reporte)
        }, (err) => {
          console.log(err)
          reject(err)
        })
    })

  }
  actualizarOADV(datos, id) {

    return new Promise((resolve, reject) => {
      this.http.put(CONFIG.API + '/api/derecho-via/' + id, datos)
        .subscribe((reporte: any) => {
          resolve(reporte)
        }, (err) => {
          console.log(err)
          reject(err)
        })
    })

  }
  obtenerOADV(id) {
    //Si la plataforma es Android se usa los métodos nativos de Ionic HTTP
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/derecho-via/' + id, {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            reject(err)
            console.log(err);
          })
      })
    } else {
      //Navegadores Brower
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/derecho-via/' + id)
          .subscribe((reporteGen: any) => {
            resolve(reporteGen)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }

  }

  obtenerNumeroMaxRegistros() {
    //Si la plataforma es Android se usa los métodos nativos de Ionic HTTP
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/derecho-via/reportes/maximo', {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      //Navegadores Brower
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/derecho-via/reportes/maximo')
          .subscribe((reporteGen: any) => {
            resolve(reporteGen)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }

  }


  obtenerReportesWithLimit(inicio) {
    //Si la plataforma es Android se usa los métodos nativos de Ionic HTTP
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/derecho-via/reportesOadv/reportesLimit/' + inicio, {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      //Navegadores Brower
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/derecho-via/reportesOadv/reportesLimit/' + inicio)
          .subscribe((reporteGen: any) => {
            resolve(reporteGen)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }

  }
  busquedaReportesGeneral(datos) {
    //Si la plataforma es Android se usa los métodos nativos de Ionic HTTP
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/derecho-via/reportes-oadv', datos, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      //Navegadores Brower
      return new Promise((resolve, reject) => {
        this.http.post(CONFIG.API + '/api/derecho-via/reportes-oadv', datos)
          .subscribe((reporteGen: any) => {
            resolve(reporteGen)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }

  }

  getEvidencias(idOadv) {
    return new Promise((resolve, reject) => {
      this.http.get(CONFIG.API + '/api/evidencias-oadv/' + idOadv)
        .subscribe((reporteGen: any) => {
          resolve(reporteGen)
        }, (err) => {
          console.log(err)
          reject(err)
        })
    })
  }

  getDocumentos(idOadv) {
    return new Promise((resolve, reject) => {
      this.http.get(CONFIG.API + '/api/documentos-oadv/' + idOadv)
        .subscribe((reporteGen: any) => {
          resolve(reporteGen)
        }, (err) => {
          console.log(err)
          reject(err)
        })
    })
  }
  getDocumento(idOadv) {
    return new Promise((resolve, reject) => {
      this.http.get(CONFIG.API + '/api/documentos-oadv/get/' + idOadv)
        .subscribe((reporteGen: any) => {
          resolve(reporteGen)
        }, (err) => {
          console.log(err)
          reject(err)
        })
    })
  }

  uploadEvidencias(form) {
    return new Promise((resolve, reject) => {
      this.http.post(CONFIG.API + '/api/evidencias-oadv/upload-web', form)
        .subscribe((reporteGen: any) => {
          resolve(reporteGen)
        }, (err) => {
          console.log(err)
          reject(err)
        })
    })
  }
  uploadDocumento(form) {
    return new Promise((resolve, reject) => {
      this.http.post(CONFIG.API + '/api/documentos-oadv/', form)
        .subscribe((reporteGen: any) => {
          resolve(reporteGen)
        }, (err) => {
          console.log(err)
          reject(err)
        })
    })
  }

  eliminarEvidencia(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(CONFIG.API + '/api/evidencias-oadv/' + id)
        .subscribe((reporteGen: any) => {
          resolve(reporteGen)
        }, (err) => {
          console.log(err)
          reject(err)
        })
    })
  }

  eliminarDocumento(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(CONFIG.API + '/api/documentos-oadv/' + id)
        .subscribe((reporteGen: any) => {
          resolve(reporteGen)
        }, (err) => {
          console.log(err)
          reject(err)
        })
    })
  }

  obtenerReportesXRecorridos(fecha) {
    //Si la plataforma es Android se usa los métodos nativos de Ionic HTTP
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/inspeccionesMR/recorridos/' + fecha, {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            reject(err)
            console.log(err);
          })
      })
    } else {
      //Navegadores Brower
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/inspeccionesMR/recorridos/' + fecha)
          .subscribe((reporteGen: any) => {
            resolve(reporteGen)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }

  }

  busquedaEventosCercanos(form) {
    return new Promise((resolve, reject) => {
      this.http.post(CONFIG.API + '/api/derecho-via/busqueda-eventos/', form)
        .subscribe((reporteGen: any) => {
          resolve(reporteGen)
        }, (err) => {
          console.log(err)
          reject(err)
        })
    })
  }

  reemplazarEvidencia(datos, id) {
    return new Promise((resolve, reject) => {
      this.http.put(CONFIG.API + '/api/evidencias-recorrido-oadv/reemplazar-web/' + id, datos)
        .subscribe((reporte: any) => {
          resolve(reporte)
        }, (err) => {
          console.log(err)
          reject(err)
        })
    })
  }
}
